export enum ApplicationEventTokenType {
  PLAIN_TEXT = 'plainText',
  JOB_POST_TITLE = 'jobPostTitle',
}

export interface IApplicationEventToken {
  index: number
  type: ApplicationEventTokenType
  value: string
  /** Job post id (e.g. contentId_locale) */
  id?: string
  /** When present, employer can navigate to this candidate's application for the job */
  applicationId?: string
}

export interface IApplicationHistoryJobTitleClickPayload {
  jobPostId: string
  applicationId?: string
}

export interface IApplicationHistory {
  text: string
  occurredAt: string
  tokens?: IApplicationEventToken[]
}
